import { render, staticRenderFns } from "./EditProfileFromToken.vue?vue&type=template&id=2251a404"
import script from "./EditProfileFromToken.vue?vue&type=script&lang=js"
export * from "./EditProfileFromToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports